import { useEffect, useState, createContext, useContext, ReactNode } from 'react';

interface AppBridgeContextValue {
  shopify: typeof window.shopify | null;
  shop: string | null;
  isEmbedded: boolean;
}

const AppBridgeContext = createContext<AppBridgeContextValue>({
  shopify: null,
  shop: null,
  isEmbedded: false,
});

export function AppBridgeProvider({ children }: { children: ReactNode }) {
  const [shopify, setShopify] = useState<typeof window.shopify | null>(null);
  const [shop, setShop] = useState<string | null>(null);

  useEffect(() => {
    // Check if running in embedded context
    if (window.shopify) {
      setShopify(window.shopify);
      // Get shop from App Bridge config
      const config = window.shopify.config;
      if (config?.shop) {
        setShop(config.shop);
      }
    } else {
      // Fallback for standalone dev mode — only if ?shop= is explicitly passed.
      // No hardcoded default: in production the embedded-app path above always runs.
      const urlParams = new URLSearchParams(window.location.search);
      const queryShop = urlParams.get('shop');
      if (queryShop) setShop(queryShop);
    }
  }, []);

  return (
    <AppBridgeContext.Provider value={{
      shopify,
      shop,
      isEmbedded: !!window.shopify
    }}>
      {children}
    </AppBridgeContext.Provider>
  );
}

export function useShopify() {
  return useContext(AppBridgeContext);
}
